import { 
    // apiBizUpdateReconcileStatus,
    // apiBizGetlandlordReportExcel,
    // apiBizGetlandlordReportDate,
    // apiBizLandlordMonthlyStatement,
    } from "@/apis/api.js"; 
import { 
    getObjectReport,
    } from "@/apis/company/landlordReport.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_landlord_report_obj: 'landlordReportDetail/set_landlord_report_obj',
    set_landlord_report_detail_obj: 'landlordReportDetail/set_landlord_report_detail_obj',
    set_landlord_report_date: 'landlordReportDetail/set_landlord_report_date',
    set_filter_query: 'landlordReportDetail/set_filter_query',
    set_filter_word: 'landlordReportDetail/set_filter_word',
    set_filter_result: 'landlordReportDetail/set_filter_result',
    set_filter_default: 'landlordReportDetail/set_filter_default',

}

// count state 必須是 Object
const state = {
    landlordReportDetailObj: null,
    filterQuery: {
        group: null,
        member: null,
        county: null,
        district: null,
        date: [],
        zero: false
    },
    filterWord: '',
    filterResult: [],
    mode: null,
    isDefault: false,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LANDLORD_REPORT_DETAIL_LIST: (state) => {
        return state.landlordReportDetailObj?state.landlordReportDetailObj.statements:[]
    },
    GET_BIZ_LANDLORD_REPORT_DETAIL_LANDLORD: (state) => {
        return state.landlordReportDetailObj?state.landlordReportDetailObj.landlordName:''
    },
    GET_BIZ_LANDLORD_REPORT_DETAIL_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_LANDLORD_REPORT_DETAIL_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_LANDLORD_REPORT_DETAIL_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_LANDLORD_REPORT_DETAIL_TOTAL: (state) => {
        const list = state.filterResult
        let data = {
            income: 0,
            incomeCount: 0,
            expense: 0,
            expenseCount: 0,
            payable: 0,
            payableCount: 0
        } 
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            data.income += element.amountVO.totalIncomeAmount
            data.incomeCount += element.amountVO.totalIncomeAmount?1:0
            data.expense += element.amountVO.totalExpenseAmount
            data.expenseCount += element.amountVO.totalExpenseAmount?1:0
            data.payable += element.amountVO.payableAmount,
            data.payableCount += element.amountVO.payableAmount?1:0
        }
        return data
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLandlordReportDetailList ( {commit, state}, params ) {
        return new Promise((resolve, reject) => {
            getObjectReport(params)
            .then(res => {
                console.log('apiBizGetlandlordReportDetail',res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_landlord_report_detail_obj, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizLandlordReportDetailFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizLandlordReportDetailFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizLandlordReportDetailFilterResult ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result, value);
            resolve()
        })
    },
    setBizLandlordReportDetailFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                group: null,
                member: null,
                county: null,
                district: null,
                date: [],
                zero: false
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_landlord_report_detail_obj](state, data){
        state.landlordReportDetailObj = data
    },
    [types.set_landlord_report_date](state, data){
        state.landlordReportDate = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result](state, data){
        state.filterResult = data
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/landlordReportDetail.js